import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import { Controller, FieldValues, UseFormReturn } from "react-hook-form";
import OneOption from "../hook-checkbox-radio/OneOption";
import OptionsDropdown from "@/app/components/common-addons-builder/common-addons-fields/hook-dropdown/options-dropdown/OptionsDropdown";
import RequiredStar from "@/app/components/lib/RequiredStar";
import InputErrorMsg from "../../form-builder-helpers/InputErrorMsg";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  field: IField;
  form: UseFormReturn<FieldValues, any>;
  isPC?: boolean;
}

const HookOptionDropdown: React.FC<Props> = ({ form, field: formField, isPC = false }) => {
  const fConfig = formField.configurations;
  const selectedKey = form.watch(fConfig.key) || [];
  const t = useTranslation();

  const onChange = (key: string) => {
    const currentSelected: string[] = [...selectedKey];
    selectedKey.includes(key)
      ? currentSelected.splice(selectedKey.indexOf(key), 1)
      : currentSelected.push(key);
    return currentSelected;
  };

  const title = selectedKey?.length > 0 
    ? selectedKey
        .map(
          (key: any) =>
            formField.data[formField.data.findIndex((o) => o.key === key)]
              ?.value,
        )
        .join(", ")
    : (fConfig.placeholder ?? "");

  return (
    <div className={`sort-dropdown w-100 ${isPC ? "pc" : ""}`}>
      {!fConfig.hideLabel && (
        <RequiredStar
          title={fConfig.title}
          isRequired={fConfig.is_required}
        />
      )}
      <Controller
        name={fConfig.key}
        control={form.control}
        rules={{
          validate: (value) =>
            fConfig.is_required && (!value || value.length === 0)
              ? t.this_field_is_required
              : true,
        }}
        render={({ field }) => (
          <OptionsDropdown
            title={title}
            isMulti
            withBorder
          >
            {formField.data?.map((item) => (
              <OneOption
                key={item.key}
                checked={selectedKey?.includes(item.key)}
                is_multi_select={true}
                toggleOption={() => field.onChange(onChange(item.key))}
                label={item.value}
              />
            ))}
          </OptionsDropdown>
        )}
      />
      {fConfig.hint && <div className="field-hint">{fConfig.hint}</div>}
      <InputErrorMsg
        errorMsg={form.formState.errors[fConfig.key]?.message as string}
      />
    </div>
  );
};

export default HookOptionDropdown;
